import Vue from 'vue';
import Vuex from 'vuex';
import Config from '@/utils/Config';
import axios from '@/service/interceptor';
import settings from '@/utils/settings';
import { getEmptyTransaction } from '@/utils/balance';
import { init } from '@/utils/market';
import _ from 'lodash';
import BigNumber from 'bignumber.js';
import mutations from './mutations';
import * as getters from './getters';
import { EDIT_ACCOUNT } from './mutation-types';

Vue.use(Vuex);

let currAccountIndex = localStorage.getItem('j-currAccountIndex');
if (currAccountIndex == null) {
    const accountList = JSON.parse(localStorage.getItem('j-accountList'));
    if (accountList) {
        currAccountIndex = 0;
    }
} else {
    currAccountIndex = parseInt(currAccountIndex, 10);
}

const debug = process.env.NODE_ENV !== 'production';
let session = localStorage.getItem('session');
if (session) {
    session = JSON.parse(session);
} else {
    session = {};
}
const userToken = session ? session.token : '';
const email = session ? session.email : '';
const bttUserid = session ? session.bttUserid : '';

const state = {
    socket: {
        isConnected: false,
        message: '',
        close: false,
        error: false,
        reconnectError: false
    },

    cashWebSocketStatus: 0,
    depthWebSocketStatus: 0,
    todayWebSocketStatus: 0,
    dealWebSocketStatus: 0,
    cancelAssetWebSocketStatus: 0,
    orderWebSocketStatus: 0,
    cancelDepthStatus: 0,
    cancelDealStatus: 0,
    newMarketData: [],
    newOrder: [],
    newAssetData: [],
    assetWebScokcetStatus: 0,
    signStatus: 0,
    balances: [],
    assetQueryStatus: 0,
    newDeal: [],
    newDepth: [],
    user: JSON.parse(localStorage.getItem('session')) || {},
    priceUSD: {},
    priceCNY: {},
    accountList: JSON.parse(localStorage.getItem('j-accountList')) || null,
    currAccountIndex,
    inviterNotExist: false,
    isShowGenerate: false,
    introOrder: false,
    introUser: false,
    email,
    session,
    bttUserid,
    userToken,
    confirmStatus: false,
    webContent: {},
    feeRate: Config.custom_no_btt_fee_rate || 0,
    kycInfo: {},
    kycToken: undefined
};

export default new Vuex.Store({
    state,
    mutations,
    actions: {
        sendMessage(context, message) {
            Vue.prototype.$socket.send(message);
        },
        async init({ commit, getters: { currAccount } }) {
            const { data } = await axios.get(
                `${settings.HOST}/bittrade/v1/me`,
                {
                    params: {
                        cmd: 'getDAppInfo'
                    }
                }
            );
            const feeRate = BigNumber(data.feeRate)
                .times(10000)
                .toNumber();
            commit('SET_FEE_RATE', feeRate);
            const { dappId } = await init();
            if (currAccount) {
                commit(EDIT_ACCOUNT, { ...currAccount, inviter: dappId });
            }
        },
        getKycToken: _.debounce(
            async (
                context,
                {
                    password,
                    forceUpdate = false,
                    account = context.getters.currAccount
                } = {}
            ) => {
                if (!account) return null;
                let token;
                if (!forceUpdate) {
                    token = (account || {}).kycToken;
                }
                if (!token) {
                    if (!password) return null;
                    const emptyTr = await getEmptyTransaction({
                        password,
                        accountInfo: account
                    });
                    const {
                        data: { userToken: kycToken } = {}
                    } = await axios.post(
                        `${settings.HOST}/bittrade/kyc/api/v1`,
                        {
                            cmd: 'getUserToken',
                            userId: account.userid,
                            transaction: JSON.stringify(emptyTr)
                        }
                    );
                    if (kycToken) token = kycToken;
                }
                if (token) {
                    const accountWithToken = { ...account, kycToken: token };
                    context.commit(EDIT_ACCOUNT, accountWithToken);
                    await context.dispatch('getKycInfo', {
                        account: accountWithToken
                    });
                }
                return token;
            },
            1000,
            { leading: true, trailing: false }
        ),
        async getKycInfo({ commit }, { account }) {
            const { data: { user, verifyType, code } = {} } = await axios.post(
                `${settings.HOST}/bittrade/kyc/api/v1`,
                {
                    cmd: 'getUserInfo',
                    userId: account.userid,
                    userToken: account.kycToken
                }
            );
            if (code !== 0) {
                commit(EDIT_ACCOUNT, { ...account, kycToken: undefined });
            }
            commit('SET_KYC_INFO', { ...user, verifyType });
        }
    },
    getters,
    strict: debug
});



// WEBPACK FOOTER //
// ./src/store/index.js